class DustJacketHelper {
  static calculateFlapWidthInInches(totalPages, productInfo) {
    if (productInfo) {
      let flapWidths = productInfo.toJS();
      for (const flapWidth of flapWidths) {
        if (totalPages <= flapWidth.pages) {
          return flapWidth.flap;
        }
      }
      console.error('Failed to get flapWidth');
    }
    return 0;
  }

  static calculateDustJacketFlapWidth(
    pageWidth,
    totalPages,
    product,
    productInfo,
  ) {
    const widthInInches = this.calculateFlapWidthInInches(
      totalPages,
      productInfo ? productInfo.get('spineSizes') : null,
    );
    let totalCoverWidthInInches = 0;

    let size =
      productInfo && productInfo.has('availableSizes')
        ? productInfo
            .get('availableSizes')
            .toJS()
            .find((e) => e.id === product)
        : 0;
    if (size) {
      totalCoverWidthInInches = size.baseCoverPageWidth;
    }

    let dpi = pageWidth / totalCoverWidthInInches;
    return widthInInches * dpi;
  }
}

export default DustJacketHelper;
